// =============================================================================
// TCT — main entry. Bootstraps libraries + global listeners. Feature code
// lives in src/js/components/*.js (auto-concatenated into this bundle).
// =============================================================================
(function ($) {
    'use strict';

    $(function () {
        if (typeof Fancybox !== 'undefined') {
            Fancybox.bind('[data-fancybox]', {});
        }

        if ($.alert) {
            $.alert.defaults = $.extend($.alert.defaults, {
                theme: 'modern',
                animation: 'scale',
                closeAnimation: 'scale',
                animationSpeed: 250,
                backgroundDismiss: true,
            });
        }

        // Smooth scroll for in-page anchor links.
        $(document).on('click', 'a[href^="#"]:not([href="#"]):not(.skip-link)', function (e) {
            const target = $(this.getAttribute('href'));
            if (target.length) {
                e.preventDefault();
                $('html, body').animate({ scrollTop: target.offset().top }, 500);
            }
        });
    });
})(jQuery);
